import { Link } from "react-router-dom"

const CopyRights = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div className="copyright">
            <p>© <span id="spanYear">{currentYear}</span> <Link to="/">Mirza Irtiza</Link>. All Rights Reserved.</p>
        </div>
    )
}

export default CopyRights